module.exports = __webpack_public_path__ + "static/media/mylogo.e8b0377f.png";